import { autoinject, transient } from 'aurelia-dependency-injection';
import { QueriesEditor } from "../../views/components/queries/queries-editor";
import { activationStrategy } from "aurelia-router";
import { computedFrom } from "aurelia-binding";
import {
    EntityTypeConfigurationHelper,
    EntityTypeConfigurationModel
} from "../../models/basics/basics.models";
import * as Enumerable from "linq";
import { Queries } from "../../views/pages/queries/queries";
import { Reflection } from "../../utilities/reflection";
import { DataGridColumn, QueryFilter } from "../../models/queries/queries.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { AllViewQueryConfigurationConstants } from "../../models/basics/view-query.models";
import { UserClaimsService } from "../../services/authentication/user-claims.service";

@autoinject
@transient()
export class ViewQueryDialog {

    private _entityTypeConfigurations: EntityTypeConfigurationModel[];

    public model: any;
    public title: string;
    public queryEditor: QueriesEditor;
    public onRowSelected: (item: any) => string;
    public clickMode: any;
    public getParams: any;
    public addRoute: any;
    public editRoute: any;
    public hasNavbar: boolean;
    public enableDownloadExcel: boolean = true;
    public addNewText: string;
    public uri: string;
    public settings: any;
    public gridSettings: any;
    public sortAlphabetically: boolean;
    public fixedColumns: DataGridColumn[] = [];
    public queryHeaderViewModel: string;
    public fixedFilters: QueryFilter[] = [];
    public onColumnPushed: ((column: DataGridColumn) => void) = () => { };
    public onColumnsPrepared: ((columns: DataGridColumn[]) => void) = () => { };
    public navBarUri: string;
    public selectionMode: 'none' | 'single' | 'multiple' = 'single';

    constructor(
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
        private dialogClientService: DialogClientService,
        private userClaimsService: UserClaimsService
    ) {
        this._entityTypeConfigurations = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions([]);
    }

    public determineActivationStrategy() {
        return activationStrategy.replace;
    }

    @computedFrom(Reflection.getPropertyPath<Queries>(x => x.queryEditor), Reflection.getPropertyPath<Queries>(x => x.queryEditor.columns), Reflection.getPropertyPath<Queries>(x => x.fixedColumns))
    get allColumns() {
        return this.queryEditor && this.queryEditor.columns && this.fixedColumns
            ? this.queryEditor.columns.concat(this.fixedColumns)
            : [];
    }

    activate(model: any) {
        this.model = model;
        this.uri = model.uri;
        this.title = model.title;
        const entityConfigurationModel = Enumerable.from(this._entityTypeConfigurations).firstOrDefault(x => x.uri && x.uri.replace(/ /g, "").toLowerCase() == this.uri.replace(/-/g, "").toLowerCase());
        const viewQueryConfigurationModel = Enumerable.from(AllViewQueryConfigurationConstants).firstOrDefault(x => x.uri && x.uri.replace(/ /g, "").toLowerCase() == this.uri.replace(/-/g, "").toLowerCase());

        if (viewQueryConfigurationModel) {
            this.title = viewQueryConfigurationModel.title;
            this.onRowSelected = viewQueryConfigurationModel.onRowSelected;
            this.settings = viewQueryConfigurationModel.settings;
            this.queryHeaderViewModel = viewQueryConfigurationModel.queryHeaderViewModel;
        }
        this.gridSettings = entityConfigurationModel.gridConfig;
        this.fixedFilters = entityConfigurationModel.filters ? entityConfigurationModel.filters : [];
        
        if (entityConfigurationModel.fixedColumns && typeof entityConfigurationModel.fixedColumns === "function") {
            this.fixedColumns = entityConfigurationModel.fixedColumns();
        } else {
            this.fixedColumns = entityConfigurationModel.fixedColumns ? entityConfigurationModel.fixedColumns as DataGridColumn[] : [];
        }
        
        this.editRoute = entityConfigurationModel.editRoute;
        this.hasNavbar = entityConfigurationModel.navbar != null && entityConfigurationModel.navbar != "";
        this.navBarUri = typeof entityConfigurationModel.navbar == "string" ? entityConfigurationModel.navbar : this.uri;

        this.clickMode = viewQueryConfigurationModel && viewQueryConfigurationModel.clickMode ? viewQueryConfigurationModel.clickMode : "double";
        this.getParams = viewQueryConfigurationModel && viewQueryConfigurationModel.getParams ? viewQueryConfigurationModel.getParams : (item: any) => ({ id: item ? item.id : 0 });
        this.sortAlphabetically = viewQueryConfigurationModel && 'sortAlphabetically' in viewQueryConfigurationModel ? viewQueryConfigurationModel.sortAlphabetically : true;
        this.onColumnPushed = viewQueryConfigurationModel && viewQueryConfigurationModel.onColumnPushed ? viewQueryConfigurationModel.onColumnPushed : () => { };
        this.onColumnsPrepared = viewQueryConfigurationModel && viewQueryConfigurationModel.onColumnsPrepared ? viewQueryConfigurationModel.onColumnsPrepared : () => { };
        this.enableDownloadExcel = entityConfigurationModel.enableDownloadExcelClaims != null && entityConfigurationModel.enableDownloadExcelClaims.length > 0 ?
            this.hasClaims(entityConfigurationModel.enableDownloadExcelClaims) : this.enableDownloadExcel;
        if(viewQueryConfigurationModel)
            this.selectionMode = viewQueryConfigurationModel.selectionMode || 'single';

        if (this.queryEditor)
            this.queryEditor.reloadData(true);
    }

    close() {
        this.dialogClientService.hide();
    }

    private hasClaims(claims: string[]): boolean {
        return this.userClaimsService.hasPermissions(claims);
    }

    @computedFrom('navBarUri')
    public getViewModel() {
        require("views/pages/queries/navbar/"+ this.navBarUri.toLowerCase() +"-navbar.ts");
        require("views/pages/queries/navbar/"+ this.navBarUri.toLowerCase() +"-navbar.html");
        return "views/pages/queries/navbar/"+ this.navBarUri.toLowerCase() +"-navbar";
    }
}
